"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import DocsSearch from "@/components/docs/DocsSearch";

const sections = [
  {
    title: "Introduction",
    items: [
      { name: "What is CompuBio?", href: "/docs" },
      { name: "Getting Started", href: "/docs/getting-started" },
    ],
  },
  {
    title: "Dashboard",
    items: [{ name: "Overview", href: "/docs/dashboard" }],
  },
  {
    title: "Analysis",
    items: [
      { name: "Bacteria Analysis", href: "/docs/analysis/bacteria" },
      { name: "Microbial Analysis", href: "/docs/analysis/microbial" },
      { name: "Diversity Analysis", href: "/docs/analysis/diversity" },
      { name: "GWAS", href: "/docs/analysis/gwas" },
    ],
  },
  {
    title: "FAQ",
    items: [{ name: "FAQ", href: "/docs/analysis/faq" }],
  },
];

export default function DocsSidebar() {
  const pathname = usePathname();

  return (
    <aside className="w-64 border-r px-4 py-6 overflow-y-auto">

      {/* 🔍 Search */}
      <DocsSearch />

      {/* 📚 Navigation */}
      {sections.map((section) => (
        <div key={section.title} className="mb-6">
          <h4 className="mb-2 text-xs font-semibold uppercase text-gray-500 tracking-wide">
            {section.title}
          </h4>

          <ul className="space-y-1">
            {section.items.map((item) => {
              const active = pathname === item.href;

              return (
                <li key={item.href}>
                  <Link
                    href={item.href}
                    className={`block rounded px-3 py-2 text-sm transition ${
                      active
                        ? "bg-indigo-600 text-white"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                  >
                    {item.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </aside>
  );
}
